import type { SvgComponent } from '@/types/SvgComponent';

export const ToggleIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M16.5 6H7.5C4.18629 6 1.5 8.68629 1.5 12C1.5 15.3137 4.18629 18 7.5 18H16.5C19.8137 18 22.5 15.3137 22.5 12C22.5 8.68629 19.8137 6 16.5 6Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 15C18.1569 15 19.5 13.6569 19.5 12C19.5 10.3431 18.1569 9 16.5 9C14.8431 9 13.5 10.3431 13.5 12C13.5 13.6569 14.8431 15 16.5 15Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
